import "./style.scss";

import { IonList, IonModal } from "@ionic/react";
import { isHCPInstantPayAllowed } from "@src/app/dayView/api";
import { UpdateShiftListFn } from "@src/app/dayView/custom-hooks/interfaces";
import { useDefinedAgent } from "@src/app/store/helperHooks";
import { ShiftPeriod } from "@src/appV2/Shifts/Shift/types";
import { Shift } from "@src/appV2/Shifts/Shift/types";
import { UrgentShift } from "@src/appV2/Shifts/UrgentShifts/api/useUrgentShifts";
import { SEARCH_MODE } from "@src/constants";
import { LegacyFacility, LegacyShift } from "@src/lib/interface/src";
import { FC, useEffect, useMemo, useState } from "react";

import { instantPayStatus } from "../../dayView/api";
import { FacilityDetails } from "../../dayView/facilityDetails";
import { ShiftItem } from "../../dayView/shiftItem";

interface UrgentShiftItemsProps {
  shifts: UrgentShift[];
  goToDocumentsPage: () => void;
  updateShiftList: UpdateShiftListFn;
  refreshShifts: () => void;
  searchMode: SEARCH_MODE;
}

export const UrgentShiftItems: FC<UrgentShiftItemsProps> = ({
  shifts,
  goToDocumentsPage,
  updateShiftList,
  refreshShifts,
  searchMode,
}) => {
  const [facilityDetails, setFacilityDetails] = useState<LegacyFacility | null>();
  const [shiftDetails, setShiftDetails] = useState<Shift | null>();
  const [isHcpInstantPayEnabled, setIsHcpInstantPayEnabled] = useState(false);

  const agent = useDefinedAgent();

  const onClickOnItemFacilityDetails = (shift: Shift) => {
    setFacilityDetails(shift.facility as LegacyFacility);
    setShiftDetails(shift);
  };

  const closeFacilityDetails = () => {
    refreshShifts();
    setFacilityDetails(null);
    setShiftDetails(null);
  };

  const availableShiftIds = useMemo(() => {
    return shifts ? shifts.map((shift) => shift.shiftId || shift._id!) : [];
  }, [shifts]);

  const fetchHcpInstantPayStatus = async () => {
    const status = await instantPayStatus();
    setIsHcpInstantPayEnabled(isHCPInstantPayAllowed(status));
  };

  useEffect(() => {
    fetchHcpInstantPayStatus();
  }, []);

  return (
    <>
      <IonList lines="none">
        {shifts?.map?.((shift) => (
          <ShiftItem
            updateShiftList={updateShiftList}
            key={shift.shiftId}
            shift={shift as LegacyShift}
            shiftName={shift.name as ShiftPeriod}
            isInterested={!!shift.interested?.find((agentId) => agentId === agent?.userId)}
            isInstantBookingShift={shift.isInstantForAgent}
            goToDocumentsPage={goToDocumentsPage}
            onFacilityDetailsClick={(shift: LegacyShift) => {
              onClickOnItemFacilityDetails(shift as Shift);
            }}
            isHcpInstantPayEnabled={isHcpInstantPayEnabled}
            isUrgentShift
            searchMode={searchMode}
            availableShiftIds={availableShiftIds}
          />
        ))}
      </IonList>

      <IonModal isOpen={!!facilityDetails} onDidDismiss={closeFacilityDetails}>
        {facilityDetails && shiftDetails && (
          <FacilityDetails
            onClose={closeFacilityDetails}
            facility={facilityDetails}
            shift={shiftDetails as LegacyShift}
          />
        )}
      </IonModal>
    </>
  );
};
